var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerProveedorInactivo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_938_1261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 0C5.82448 0.00825469 0.00825484 5.96058 0 13.3066C0 16.7329 2.59202 22.0957 7.70452 29.245C9.83977 32.2387 13.9417 32.8943 16.866 30.7088C17.4143 30.2995 17.8965 29.8056 18.2962 29.245C23.4087 22.0957 26.0007 16.7329 26.0007 13.3066C25.9924 5.96058 20.1762 0.00825469 13 0Z",
    fill: "#C03636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5847 5.88624H13.7788C13.9136 5.48451 13.8655 4.92388 14.3862 4.82345C15.8494 4.89155 17.4391 4.70582 18.8886 4.8145C19.5042 4.86059 19.4705 5.41159 19.5847 5.88624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 19.6056V7.32949C13 7.16234 13.3261 6.91126 13.5029 6.92364L19.8618 6.92226C20.0503 6.8858 20.3956 7.19604 20.3956 7.36114V19.5568C20.3956 19.5602 20.3502 19.6056 20.3468 19.6056H13ZM16.1465 9.06436H15.1084V11.1404H16.1465V9.06436ZM18.2549 9.06436H17.2168V11.1404H18.2549V9.06436ZM16.1465 12.7625H15.1084V14.8385H16.1465V12.7625ZM18.2549 12.7625H17.2168V14.8385H18.2549V12.7625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9621 11.1404V13.2323C11.9621 13.2357 11.9167 13.2811 11.9133 13.2811H7.74525V14.3191H11.9621V15.9082H7.74525V16.9462H11.9621V19.5574C11.9621 19.5609 11.9167 19.6063 11.9133 19.6063H5.60449V12.0656C5.60449 11.6989 6.16238 11.1411 6.52903 11.1411H11.9621V11.1404Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_938_1261"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerProveedorInactivo);
export default __webpack_public_path__ + "static/media/markerProveedorInactivo.058e155cdf8e673b235e7237398d4f25.svg";
export { ForwardRef as ReactComponent };